import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';

// services
import { LoginService } from '../../../shared/services/login.service';
import { SessionService } from '../../../shared/services/session.service';
import { CopyService } from '../../../shared/services/app-copy.service';

// ngrx store
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

// models
import { AppState } from '../../../booking/models/app-state.interface';

@Component({
  selector: 'app-two-factor',
  templateUrl: './two-factor.component.html',
  styleUrls: ['./two-factor.component.scss']
})
export class TwoFactorComponent implements OnInit, OnDestroy {

  @Input()
  sessionID: string;

  @Input()
  userEmail: string;

  @Input()
  userHasPassword: boolean;

  @Input()
  userHasPhoneNumber: boolean;

  @Output()
  closeOverlay: EventEmitter<any> = new EventEmitter();

  @Output()
  toggleLoginType: EventEmitter<any> = new EventEmitter();

  private _verifySmsSentSubscription: Subscription;
  private _magicLinkSentSubscription: Subscription;
  private _validateSmsCodeSubscription: Subscription;
  private _userLanguageSubscription: Subscription;
  private _bookingInitSubscription: Subscription;

  public activePanel = 'intro';
  public phoneNumber = '';
  public smsCode = {
    'digit1': '',
    'digit2': '',
    'digit3': '',
    'digit4': ''
  };
  public smsCodeToken = '';
  public showVerifySmsLoader = false;
  public showMagicLinkLoader = false;
  public showVerifyCodeBtn = false;
  public showValidateCodeLoader = false;
  public appCopy;
  public copyLoaded: Boolean = false;
  public selectedLanguage = '';
  public showCurrencyWithPrice = '';

  constructor(
    private _appStore: Store<AppState>,
    private _loginService: LoginService,
    private _sessionService: SessionService,
    private _copyService: CopyService,
    private _activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {

    this.showCurrencyWithPrice = this._activatedRoute.snapshot.queryParams.currencySymbol;
    this._userLanguageSubscription = this._appStore.select('copyReducer')
      .subscribe((res: any) => {
        this.selectedLanguage = res.language
      })

    this._bookingInitSubscription = this._appStore.select('loadedStatusReducer')
      .subscribe((res: any) => {
        this.copyLoaded = res.copyLoaded;
        if (res.copyLoaded) {
          this.getCopy();
        }

      })

    this._verifySmsSentSubscription = this._loginService.verifySmsSent$
      .subscribe(phoneNumber => {
        this.showVerifySmsLoader = false;

        if (phoneNumber) {
          this.phoneNumber = phoneNumber;
          this.activePanel = 'sms';
        }
      },
        err => console.log(err));

    this._magicLinkSentSubscription = this._loginService.magicLinkSent$
      .subscribe(res => {
        this.showMagicLinkLoader = false;

        if (res) {
          this.activePanel = 'email';
        }
      },
        err => console.log(err));

    this._validateSmsCodeSubscription = this._loginService.validateSmsCode$
      .subscribe(res => {

        if (res.error) {
          this.showValidateCodeLoader = false;
        } else {
          this.handleCloseOverlay();
        }
      },
        err => console.log(err));
  }

  getCopy() {
    const panelHeaderCopy = this._copyService.getCopyBySection(
      'OTHER',
      'login',
      ['two-factor']
    );
    console.log(panelHeaderCopy)

    this.appCopy = {
      panelHeader: panelHeaderCopy[0],
    };

  }


  handleCloseOverlay() {
    this.closeOverlay.emit();
  }

  showPasswordLogin() {
    this.toggleLoginType.emit(1);
  }

  sendVerifySms() {
    this._loginService.sendVerifySms(this.userEmail);
    this.showVerifySmsLoader = true;
  }

  sendMagicLink() {
    this._loginService.sendMagicLink(this.userEmail, this.sessionID);
    this.showMagicLinkLoader = true;
  }

  handleDigitChange(value, index) {

    if (value === '') {
      this.smsCode['digit' + index] = '';
    } else {
      const digit = value.substr(-1);

      if (digit >= 0 && digit <= 9) {
        this.smsCode['digit' + index] = digit;
      }
    }

    this.checkCode();
  }

  checkCode() {
    const code = this.smsCode.digit1 + this.smsCode.digit2 + this.smsCode.digit3 + this.smsCode.digit4;

    if (code.length === 4) {
      this.showVerifyCodeBtn = true;
      this.smsCodeToken = code + '05';
    } else {
      this.showVerifyCodeBtn = false;
    }
  }

  validateSmsCode() {
    this.showValidateCodeLoader = true;
    this._loginService.validateSmsCode(this.smsCodeToken, this.userEmail);
  }

  ngOnDestroy() {
    this._verifySmsSentSubscription.unsubscribe();
    this._magicLinkSentSubscription.unsubscribe();
    this._validateSmsCodeSubscription.unsubscribe();
  }

}
